import PropTypes from 'prop-types';
import { lazy } from 'react';
import { getConfig } from '@fec/assets/js/utils/config';
const InlineAudio = lazy(
  () => import('@fec/frontend-aron/modules/media/InlineAudio/InlineAudio'),
);
const InlineAudioApp = lazy(
  () =>
    import('@fec/frontend-aron/modules/media/InlineAudioApp/InlineAudioApp'),
);

import './AudioGalleryItem.scss';

const AudioGalleryItem = ({ asset }) => {
  const config = getConfig();
  const representation = config.REPRESENTATION ?? 'web';
  const isWebview = representation.includes('webview');
  const AudioComponent = isWebview ? InlineAudioApp : InlineAudio;

  return (
    <li className="audio-gallery__item">
      <AudioComponent
        asset={asset}
        styleModifier="inline-audio--audio-gallery"
      />
    </li>
  );
};

AudioGalleryItem.propTypes = {
  asset: PropTypes.object,
};

export default AudioGalleryItem;
